import React, { useEffect, useState } from 'react';
import { companyService, consignorService } from '../../../services';
import { Modal, Row, Col, Table, Icon, Button } from 'antd';
import Spinner from "../../spinner";
import moment from "moment";
import DividerBlock from '../../divider-block';
import TableModal from '../table-modal';
import i18n from "i18next";

export default function ModalDeliveryInfo({ deliveryInfo, deliveryId, isShow, setIsShow }) {

	const [tableData, setTableData] = useState([]);
	const [dataDelivery, setDataDelivery] = useState([]);
	const [reportData, setReportData] = useState([]);
	const [deliveryChanges, setDeliveryChanges] = useState([]);
	const [deliveryOffers, setDeliveryOffers] = useState([]);
	const [deliveryStatusChanges, setDeliveryStatusChanges] = useState([]);
	const [prices, setPrices] = useState([]);

	const [modalTableTitle, setModalTableTitle] = useState(false);
	const [modalTableColumns, setModalTableColumns] = useState([]);
	const [modalTableData, setModalTableData] = useState([]);
	const [modalTableShow, setModalTableShow] = useState(false);

	useEffect(() => {
		if (isShow && deliveryInfo !== undefined) {
			setDataDelivery(deliveryInfo.deliveryInfo);
			setTableData(deliveryInfo.ordersDelivery);
			setPrices(deliveryInfo.deliveryInfo.deliveryPrices);
			setDeliveryChanges(deliveryInfo.deliveryChanges);
			setDeliveryStatusChanges(deliveryInfo.deliveryStatusChanges);
			setDeliveryOffers(deliveryInfo.offersDelivery);

			if (deliveryInfo.ordersDelivery) {
				deliveryInfo.ordersDelivery.map((item, index) => {
					tableData[index] = {
						number: index,
						fio: item.name,
						price: item.price,
						title: item.title,
						legalEntityName: item.legal_entity_name,
						date_created: moment(item.date_created).format("DD.MM.YYYY HH:mm:ss"),
						last_update: moment(item.last_update).format("DD.MM.YYYY HH:mm:ss"),
						date_delivery: moment(item.date_delivery).format("DD.MM.YYYY"),
						statusChanges: item.statusChanges,
						children: []
					};
					if (item.counterOffers.length !== 0) {
						item.counterOffers.map((val, index2) => {
							tableData[index].children.push({
								key: 'offer'+index2,
								type: i18n.t('modals.modalDeliveryInfo.counterOffers'),
								fio: val.name,
								price: val.sum,
								title: val.title,
								date_created: moment(val.date_created).format("DD.MM.YYYY HH:mm:ss"),
								last_update: moment(val.date_updated).format("DD.MM.YYYY HH:mm:ss"),
							});
						});
					}
					if (item.history.length !== 0) {
						item.history.map((val, index2) => {
							tableData[index].children.push({
								key: 'history'+index2,
								type: val.type,
								legalEntityName: val.info,
								price: (val.data ? val.data.price : ''),
								title: '',
								date_created: moment(val.date_created).format("DD.MM.YYYY HH:mm:ss"),
								last_update: '',
							});
						});
					}
					return null;
				});

				let reindexedTableData = [];
				for (let key in tableData) {
					reindexedTableData.push(tableData[key]);
				}

				setReportData(reindexedTableData);
			} else {
				setReportData([]);
			}
		}
	}, [isShow]);

	const changesCol = [
		{
			title: i18n.t('modals.modalDeliveryInfo.table.old.title'),
			key: 'old',
			width: '50%',
			render: val => {
				return val.old.map((v, i) => (
					<p><b>{i+1}.</b> {v}</p>
				));
			}
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.new.title'),
			key: 'new',
			width: '50%',
			render: val => {
				return val.new.map((v, i) => (
					<p><b>{i+1}.</b> {v}</p>
				));
			}
		},
	];

	const statusCol = [
		{
			title: i18n.t('modals.modalDeliveryInfo.table.status.title'),
			dataIndex: 'status',
			key: 'status',
			width: '33%'
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.date.title'),
			key: 'date',
			width: '33%',
			render: val => {
				return moment(val.date).format("DD.MM.YYYY HH:mm:ss");
			}
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.user.title'),
			dataIndex: 'user',
			key: 'user',
			width: "33%"
		},
	];

	const offerCol = [
		{
			title: i18n.t('modals.modalDeliveryInfo.table.legalEntityName.title'),
			dataIndex: 'legal_entity_name',
			key: 'legal_entity_name',
			width: "20%"
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.name.title'),
			dataIndex: 'name',
			key: 'name',
			width: "15%"
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.price.title'),
			dataIndex: 'price',
			key: 'price',
			width: "10%"
		},
		{
			title: i18n.t('Дата загрузки'),
			render: v => {
				return moment(v.date_loading).format('DD.MM.YYYY');
			},
			key: 'date_loading',
			width: "12%"
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.status.title'),
			dataIndex: 'status',
			key: 'status',
			width: "10%",
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.dateCreated.title'),
			render: v => {
				return moment(v.date_created).format('DD.MM.YYYY HH:mm:ss');
			},
			key: 'date_created',
			width: "12%"
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.lastUpdate.title'),
			render: v => {
				return moment(v.date_updated).format('DD.MM.YYYY HH:mm:ss');
			},
			key: 'date_updated',
			width: "12%"
		},
	]

	const columns = [
		{
			dataIndex: 'type',
			key: 'type',
			width: '20%'
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.legalEntityName2.title'),
			dataIndex: 'legalEntityName',
			key: 'legalEntityName',
			width: '15%'
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.price.title'),
			dataIndex: 'price',
			key: 'price',
			width: "10%"
		},
		{
			title: i18n.t('Дата загрузки'),
			dataIndex: 'date_delivery',
			key: 'date_delivery',
			width: "10%"
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.status.title'),
			key: 'title',
			width: "15%",
			render: val => {
				return(
					<>
					{val.title}

					{val.statusChanges && <Button
						style={{border: "none", outline: "none"}}
						type="primary"
						size='small'
						icon="question-circle-o"
						onClick={() => {
							setModalTableTitle(i18n.t('modals.modalDeliveryInfo.orderStatusHistory', {name: val.legalEntityName}));
							setModalTableColumns(statusCol);
							setModalTableData(val.statusChanges);
							setModalTableShow(true);
						}}
					>
					</Button>}
					</>
				)
			}
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.dateCreated.title'),
			dataIndex: 'date_created',
			key: 'date_created',
			width: "10%"
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.lastUpdate.title'),
			dataIndex: 'last_update',
			key: 'last_update',
			width: "10%"
		},
	];

	const columnsDelivery = [
		{
			title: i18n.t('modals.modalDeliveryInfo.table.type.title'),
			dataIndex: 'type',
			key: 'type',
			width: '25%'
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.info.title'),
			key: 'info',
			width: '25%',
			render: val => {
				console.log(val.data);
				if(val.data && val.data.changes) {
					return (<Button
						style={{border: "none", outline: "none"}}
						type="primary"
						size='small'
						icon="question-circle-o"
						onClick={() => {
							setModalTableTitle(val.type);
							setModalTableColumns(changesCol);
							setModalTableData([val.data.changes]);
							setModalTableShow(true);
						}}
					>
					</Button>);
				}
				if(val.info) {
					return val.info;
				}
			}
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.user.title'),
			dataIndex: 'user',
			key: 'user',
			width: '25%'
		},
		{
			title: i18n.t('modals.modalDeliveryInfo.table.date.title'),
			//dataIndex: 'date_created',
			key: 'date_created',
			width: "25%",
			render: val => {
				return moment(val.date_created).format("DD.MM.YYYY HH:mm:ss");
			}
		},
	];


	return (
		<>
		<Modal
			title={i18n.t('modals.modalDeliveryInfo.title',{number: dataDelivery.number_delivery})}
			cancelText={i18n.t('main.buttons.close')}
			className="modal-window"
			align={null}
			visible={isShow}
			onCancel={() => {
				setIsShow(false);
			}}
			footer={<div></div>}
		>
			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label calendar" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.name.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{dataDelivery.name}
				</Col>
			</Row>

			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label calendar" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.dateApproved.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{dataDelivery.date_approved != null ? moment(dataDelivery.date_approved).format("DD.MM.YYYY HH:mm:ss") : dataDelivery.date_approved}
				</Col>
			</Row>

			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label calendar" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.status.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{dataDelivery.delivery_status_title}
					<Button
						style={{border: "none", outline: "none"}}
						type="primary"
						size='small'
						icon="question-circle-o"
						onClick={() => {
							setModalTableTitle(i18n.t('modals.modalDeliveryInfo.statusHistory', {number: dataDelivery.number_delivery}));
							setModalTableColumns(statusCol);
							setModalTableData(deliveryStatusChanges);
							setModalTableShow(true);
						}}
					>
					</Button>
				</Col>
			</Row>

			{prices.map(item => {
				return (
					<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
						<Col lg={12} md={12} sm={12} xs={12} className="label calendar" style={{ marginBottom: '10px' }}>
							{item.paymentType.title}:
						</Col>
						<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
							{item.price} {item.paymentType.currency.symbol}
						</Col>
					</Row>
				);
			})}
			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label patch" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.dateShipment.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{dataDelivery.date_shipment != null ? moment(dataDelivery.date_shipment).format("DD.MM.YYYY") : ""}
				</Col>
			</Row>
			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label calendar" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.dateCreated.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{moment(dataDelivery.date_created).format("DD.MM.YYYY HH:mm:ss")}
				</Col>
			</Row>
			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label dispatch" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.maxDate.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{dataDelivery.max_date !== "-" ? moment(dataDelivery.max_date).format("DD.MM.YYYY HH:mm:ss") : "-"}
				</Col>
			</Row>
			<Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
				<Col lg={12} md={12} sm={12} xs={12} className="label dispatch" style={{ marginBottom: '10px' }}>
          {i18n.t('modals.modalDeliveryInfo.fields.dateDiff.title')}:
				</Col>
				<Col lg={12} md={12} sm={12} xs={12} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
					{dataDelivery.date_diff}
				</Col>
			</Row>
			{(deliveryChanges && deliveryChanges.length > 0) &&
			<>
				<Table
					title={() => { return(<h5>{i18n.t('modals.modalDeliveryInfo.tableTitle')}</h5>); }}
					columns={columnsDelivery}
					dataSource={deliveryChanges}
					rowKey="changes"
					locale={{ emptyText: i18n.t('main.empty') }}
					pagination={false}
					size="small"
				/>
				<DividerBlock/>
			</>
			}
			<Table
				title={() => { return(<h5>{i18n.t('modals.modalDeliveryInfo.tableTitle2')}</h5>); }}
				columns={columns}
				dataSource={reportData}
				rowKey="name"
				locale={{ emptyText: i18n.t('main.empty') }}
				pagination={false}
				size="small"
			/>
			{(deliveryOffers && deliveryOffers.length > 0) &&
			<>
				<DividerBlock/>
				<Table
					title={() => { return(<h5>{i18n.t('modals.modalDeliveryInfo.tableTitle3')}</h5>); }}
					columns={offerCol}
					dataSource={deliveryOffers}
					rowKey="name"
					locale={{ emptyText: i18n.t('main.empty') }}
					pagination={false}
					size="small"
				/>
			</>}
		</Modal>
		<TableModal
			isShow={modalTableShow}
			setIsShow={setModalTableShow}
			columns={modalTableColumns}
			data={modalTableData}
			title={modalTableTitle}
		/>
		</>
	);

}
